import Users from '../components/Users/Users';
import Companies from '../components/Companies/Companies';
import CreateCompany from '../components/CreateCompany/CreateCompany';
import Attributes from '../components/Attributes/Attributes';
import Market from '../components/Market/Market';
import Apk from '../components/Application/Application';
import CompaniesStat from '../components/Statistics/CompaniesStat/CompaniesStat.js';
import CompanyStat from '../components/Statistics/CompanyStat/CompanyStat.js';
import StoreStat from '../components/Statistics/StoreStat/StoreStat.js';
import AppsStat from '../components/Statistics/AppsStat/AppsStat.js';
import PromoSummaryStat from "../components/Promo/PromoSummaryStat/PromoSummaryStat";
import ClientUpdate from "../components/ClientUpdate/ClientUpdate";
import PromoterCategory from "../components/Promoter/PromoterCategory/PromoterCategory";
import PromoterSection from "../components/Promoter/PromoterSection/PromoterSection";
import PromoterVideo from "../components/Promoter/PromoterVideo/PromoterVideo";
import PromoterSalesPointActiveDevices
    from "../components/Promoter/PromoterSalesPointActiveDevices/PromoterSalesPointActiveDevices";
import PromoterVideoStats from "../components/Promoter/PromoterVideoStats/PromoterVideoStats";
import PromoterSalesPointStats from "../components/Promoter/PromoterSalesPointStats/PromoterSalesPointStats";
import LoanOrders from "../components/Loan/Order/LoanOrders";
import LoanOrderInfo from "../components/Loan/Order/LoanOrderInfo";
import LoanOrderCreation from "../components/Loan/Order/LoanOrderCreation";
import LoanSummaryProps from "../components/Loan/Property/Summary/LoanSummaryProps";
import LoanAvailableProps from "../components/Loan/Property/Available/LoanAvailableProps";
import PlayerFolder from "../components/Player/PlayerFolder/PlayerFolder";
import PlayerMedia from "../components/Player/PlayerMedia/PlayerMedia";
import PlayerActiveSalesPoints from "../components/Player/PlayerActiveSalesPoints/PlayerActiveSalesPoints";
import PlayerMediaStats from "../components/Player/PlayerMediaStats/PlayerMediaStats";
import PlayerSalesPointStats from "../components/Player/PlayerSalesPointStats/PlayerSalesPointStats";
import promoterLogo from "../assets/images/promoter-logo.svg";

const AdminRoutes = [
	{
		collapse: false,
		path: "/",
		name: {
			"ru": "Главная",
			"en": "Main",
			"sk": "Hlavná"
		},
		state: "home",
		icon: "mdi mdi-home",
	},
	{
		navlabel: true,
		name: {
			"ru": "Администрирование",
			"en": "Administration",
			"sk": "Podávanie"
		},
		icon: "mdi mdi-dots-horizontal",
	},
	{
		collapse: false,
		path: "/dashboard/users",
		name: {
			"ru": "Пользователи",
			"en": "Users",
			"sk": "Užívatelia"
		},
		state: "users",
		icon: "mdi mdi-account-circle",
		component: Users
		// child: [
		// 	{
		// 		path: "/dashboard/users",
		// 		name: "Cписок пользователей",
		// 		mini: "B",
		// 		icon: "mdi mdi-account-multiple",
		// 		component: Users
		// 	},
		// 	// {
		// 	// 	path: "/dashboard/users/add",
		// 	// 	name: "Создание пользователя",
		// 	// 	mini: "B",
		// 	// 	icon: "mdi mdi-account-add",
		// 	// 	component: User
		// 	// },
		// 	{
		// 		path: "/dashboard/roles/add",
		// 		name: "Создание роли",
		// 		mini: "B",
		// 		icon: "mdi mdi-account-star",
		// 		component: Role
		// 	},
		// 	{
		// 		path: "/dashboard/roles",
		// 		name: "Настройка роли",
		// 		mini: "B",
		// 		icon: "mdi mdi-account-settings-variant",
		// 		component: Roles
		// 	},
		// ]
	},
	{
		collapse: false,
		path: "/dashboard/companies",
		name: {
			"ru": "Компании",
			"en": "Companies",
			"sk": "Firmy"
		},
		state: "companies",
		icon: "mdi mdi-city",
		component: Companies
		// child: [
		// 	{
		// 		path: "/dashboard/companies",
		// 		name: "Cписок компаний",
		// 		mini: "B",
		// 		icon: "mdi mdi-city",
		// 		component: Companies
		// 	},
		// ]
	},
	{
		collapse: false,
		path: "/dashboard/market",
		name: {
			"ru": "Маркет",
			"en": "Market",
			"sk": "Trhové",
		},
		state: "market",
		icon: "mdi mdi-apps",
		component: Market,
		// child: [
		// 	{
		// 		path: "/dashboard/market",
		// 		name: "Маркет",
		// 		mini: "B",
		// 		icon: "mdi mdi-apps",
		// 		component: Market
		// 	},
		// 	{
		// 		path: "/dashboard/market/add",
		// 		name: "Загрузка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-upload",
		// 		component: UploadApk
		// 	},
		// 	{
		// 		path: "/dashboard/market/app",
		// 		name: "Настройка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-border-color",
		// 		component: Apk
		// 	},
		//]
	},
	{
		collapse: false,
		path: "/dashboard/attributes",
		name: {
			"ru": "Атрибуты",
			"en": "Attributes",
			"sk": "Atribúty"
		},
		state: "attributes",
		icon: "mdi mdi-view-dashboard",
		component: Attributes
		// child: [
		// 	{
		// 		path: "/dashboard/attributes",
		// 		name: "Cписок аттрибутов",
		// 		mini: "B",
		// 		icon: "mdi mdi-view-list",
		// 		component: Attributes
		// 	},
		// 	{
		// 		path: "/dashboard/attributes/add",
		// 		name: "Cоздание атрибута",
		// 		mini: "B",
		// 		icon: "mdi mdi-view-quit",
		// 		component: Attribute
		// 	},
		// ]
	},
	{
		collapse: true,
		path: "/dashboard/statistics",
		name: {
			"ru": "Статистика",
			"en": "Statistics",
			"sk": "Štatistika"
		},
		state: "statistics",
		icon: "mdi mdi-information",
		child: [
			{
				path: "/dashboard/statistics/companies",
				name: {
					"ru": "По организациям",
					"en": "By companies",
					"sk": "Podľa spoločností"
				},
				mini: "B",
				icon: "mdi mdi-houzz",
				component: CompaniesStat
			},
			// {
			// 	path: "/dashboard/statistics/stores",
			// 	name: {
			// 		"ru": "По торговым точкам",
			// 		"en": "By trader points"
			// 	},
			// 	mini: "B",
			// 	icon: "mdi mdi-houzz-box",
			// 	component: StoresStat
			// },
			{
				path: "/dashboard/statistics/apps",
				name: {
            		"ru": "По приложениям",
            		"en": "By apps",
                    "sk": "Podľa aplikácií"
            	},
				mini: "B",
				icon: "mdi mdi-animation",
				component: AppsStat
			},
			{
				path: "/dashboard/statistics/offers",
				name: {
					"ru": "По оферам",
					"en": "By offers",
					"sk": "Podľa ponúk"
				},
				mini: "B",
				icon: "mdi mdi-houzz",
				component: PromoSummaryStat
			}
		]
	},
	{
		collapse: true,
		path: "/dashboard/player",
		name: {
			"ru": "Плеер",
			"en": "Player",
			"sk": "Player"
		},
		state: "player",
		icon: "mdi mdi-play-circle-outline",
		child: [
			{
				path: "/dashboard/player/folders",
				name: {
					"ru": "Папки",
					"en": "Folders",
				},
				mini: "B",
				icon: "mdi mdi-folder-multiple",
				component: PlayerFolder
			},
			{
				path: "/dashboard/player/media",
				name: {
					"ru": "Медиа",
					"en": "Media",
				},
				mini: "B",
				icon: "mdi mdi-file-multiple",
				component: PlayerMedia
			},
			{
				path: "/dashboard/player/stats/activeSalesPoints",
				name: {
					"ru": "Активные торговые точки",
					"en": "Active sales points",
				},
				mini: "B",
				icon: "mdi mdi-store",
				component: PlayerActiveSalesPoints
			},
			{
				path: "/dashboard/player/stats/media",
				name: {
					"ru": "Воспроизведений медиа",
					"en": "Media playback amount",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerMediaStats
			},
			{
				path: "/dashboard/player/stats/store",
				name: {
					"ru": "Воспроизведений по тт",
					"en": "Playback amount by stores",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerSalesPointStats
			},
		]
	},
	{
		collapse: true,
		path: "/dashboard/promoter",
		name: {
			"ru": "Promoter",
			"en": "Promoter",
			"sk": "Promoter"
		},
		state: "promoter",
		svgIcon: promoterLogo,
		child: [
			{
				path: "/dashboard/promoter/videos",
				name: {
					"ru": "Библиотека медиа",
					"en": "Media library",
				},
				mini: "B",
				icon: "mdi mdi-file-video",
				component: PromoterVideo
			},
			{
				collapse: true,
				name: {
					"ru": "Статистика",
					"en": "Statistics",
				},
				state: "promoterStatistics",
				icon: "mdi mdi-settings-box",
				subchild: [
					{
						path: "/dashboard/promoter/stats/video",
						name: {
							"ru": "Отчет о воспроизведении",
							"en": "Playback report",
						},
						mini: "B",
						icon: "mdi mdi-format-list-bulleted",
						component: PromoterVideoStats
					},
					{
						path: "/dashboard/promoter/stats/store",
						name: {
							"ru": "Отчет по магазинам",
							"en": "Store playback report",
						},
						mini: "B",
						icon: "mdi mdi-format-list-bulleted",
						component: PromoterSalesPointStats
					},
					{
						path: "/dashboard/promoter/stats/activeDevices",
						name: {
							"ru": "Активные устройства",
							"en": "Active devices",
						},
						mini: "B",
						icon: "mdi mdi-cellphone-andrAdminid",
						component: PromoterSalesPointActiveDevices
					},
				]
			},
			{
				collapse: true,
				name: {
					"ru": "Настройки",
					"en": "Settings",
					"sk": "Nastavenie"
				},
				state: "promoterSettings",
				icon: "mdi mdi-settings-box",
				subchild: [
					{
						path: "/dashboard/promoter/categories",
						name: {
							"ru": "Категории",
							"en": "Categories",
						},
						mini: "B",
						icon: "mdi mdi-folder-multiple",
						component: PromoterCategory
					},
					{
						path: "/dashboard/promoter/sections",
						name: {
							"ru": "Разделы",
							"en": "Sections",
						},
						mini: "B",
						icon: "mdi mdi-folder-multiple-outline",
						component: PromoterSection
					},]
			},
		]
	},
	{
		collapse: true,
		path: "/dashboard/loan",
		name: {
			"ru": "Кредиты",
			"en": "Loans",
			"sk": "Úver"
		},
		state: "loan-orders",
		icon: "mdi mdi-credit-card",
		child: [
			{
				path: "/dashboard/loan/orders",
				name: {
					"ru": "Заявки",
					"en": "Orders",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: LoanOrders,
			},
			{
				path: "/dashboard/loan/settings",
				name: {
					"ru": "Налаштування",
					"en": "Settings",
				},
				mini: "B",
				icon: "mdi mdi-settings",
				component: LoanSummaryProps
			}
		]
	},
	{
		collapse: false,
		path: "/dashboard/client",
		name: {
			"ru": "Обновление клиента",
			"en": "Client update",
			"sk": "Aktualizácia klienta"
		},
		state: "promo-video",
		icon: "mdi  mdi-update",
		component: ClientUpdate
	},
	{
        collapse: false,
		path: "/chat",
		isLink: true,
        name: {
            "ru": "Поддержка",
            "en": "Support",
            "sk": "Podpora"
        },
        state: "chat",
        icon: "mdi mdi-comment-multiple-outline"
    },
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/market/:appid",
		state: "app",
		component: Apk,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/companies/:companyid",
		state: "company-statistics",
		component: CompanyStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/stores/:storeid",
		state: "point-statistics",
		component: StoreStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/statistics/apps/:appid",
		state: "point-statistics",
		component: AppsStat,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/companies/add",
		//name: "Создание компании",
		//mini: "B",
		//icon: "mdi mdi-library-plus",
		state: "company-create",
		component: CreateCompany
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/info/:orderId",
		state: "loan-order",
		component: LoanOrderInfo,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/create",
		state: "loan-order-creation",
		component: LoanOrderCreation,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/settings/:bankIntegration",
		state: "loan-order-creation",
		component: LoanAvailableProps,
	},
];
export default AdminRoutes;



// WEBPACK FOOTER //
// ./src/routes/adminRoutes.js